import ApiService from './ApiService';

class BackOfficeService {
  async getBackOfficerList(payload) {
    try {
      const response = await ApiService.call('/secured/get_backoffice_user_list', 'POST', payload);

      return {
        backOfficeUserList: response.backOfficeUserDataList,
        totalCount: response.totalCount,
        page: response.offset,
        size: response.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async createBackOfficer(payload) {
    try {
      const response = await ApiService.call('/secured/create_backoffice_user', 'POST', payload);

      return {
        data: response,

        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async updateProfile(payload) {
    try {
      const response = await ApiService.call('/secured/update_profile', 'POST', payload);

      return {
        data: response,

        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async resetPassword(payload) {
    try {
      const response = await ApiService.call('/secured/reset_password', 'POST', payload);

      return {
        data: response,

        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async modifyUserStatus(payload) {
    try {
      const response = await ApiService.call('/secured/modify_user_status', 'POST', payload);

      return {
        data: response,

        success: true,
      };
    } catch (error) {
      let data = error.response.data;
      return {
        success: false,
        code: data.error,
        message: data.message,
      };
    }
  }

  async deleteUser(payload) {
    try {
      const response = await ApiService.call('/secured/delete_backoffice_user', 'POST', payload);

      return {
        data: response,

        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new BackOfficeService();
